<div class="full-path-toggle">
  <span>{{ toggleLabel }}</span>
  <coreui-toggle
    [checked]="displayFullSegmentPath$ | async"
    (valueChange)="toggleFullSegmentPath($event)"
  ></coreui-toggle>
</div>
